import React from 'react';

export const KindraLogo = ({ size = 'default', showText = true, className = '' }) => {
  const sizes = {
    small: { img: 'w-10 h-10', text: 'text-lg' },
    default: { img: 'w-16 h-16', text: 'text-2xl' },
    large: { img: 'w-32 h-32', text: 'text-4xl' },
    xlarge: { img: 'w-40 h-40', text: 'text-5xl' }
  };
  const s = sizes[size] || sizes.default;

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <img
        src="/kindra-logo.png"
        alt="Kindra"
        className={`${s.img} object-contain`}
      />
      {showText && (
        <h1 className={`${s.text} font-light tracking-tight text-slate-900 mt-4`} style={{ fontFamily: 'Outfit, sans-serif' }}>
          Kindra
        </h1>
      )}
    </div>
  );
};

export const LoadingScreen = () => (
  <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center">
    <div className="text-center">
      <img
        src="/kindra-logo.png"
        alt="Kindra"
        className="w-20 h-20 mx-auto mb-4 animate-pulse-gentle object-contain"
      />
      <p className="text-slate-500 font-medium">Loading...</p>
    </div>
  </div>
);
